import { baseUCGet } from '../base/baseUC';

const str = '';

export const peopleTypeModelGet = ({userId = '',}) => {
    return {
        description: str,
        ...baseUCGet({userId: userId,}),
    };
}